import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = {
  key: 0,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_5 = {
  key: 0,
  class: "text-sm-body-2 text-red mt-1"
}
const _hoisted_6 = {
  key: 0,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_7 = {
  key: 1,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "float-right d-flex" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-grey" }

import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import UserQuestionForm from '../../../api/v2/forms/user_question'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { checkMobile } from '../../utils/utils'
import { userQuestionState } from '../../stores/user_quetions'
import markdownParser from '../../../../helpers/markdown-parser'
import { ROUTER_NAME } from "../../router"
import { eventBus, EVENTS } from '../../utils/eventBus'

const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB


export default /*@__PURE__*/_defineComponent({
  __name: 'UserQuestionFormView',
  props: {
    courseId: { default: '' },
    lessonId: { default: '' },
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const route = useRoute()

const vModel = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit('update:modelValue', val)
})

const hasAsked = ref(false)
const isNotConfirm = ref(true)
const confirmed = ref(false)

const title = ref('')
const body = ref('')
const invalidTitle = ref(false)
const invalidBody = ref(false)
const invalidFiles = ref(false)
const questionType = ref('nomal_question')
const materials = ref<File[]>([])
const mobile = checkMobile()

const fileRules = [
  (files: File[]) => {
    if (!files || files.length === 0) return true
    return files.every(f => f.size <= MAX_FILE_SIZE) || 'ファイルサイズは5MB以下にしてください'
  }
]

const validateFiles = (files: File[]) => {
  invalidFiles.value = files.some(f => f.size > MAX_FILE_SIZE)
  if (invalidFiles.value) {
    materials.value = files.filter(f => f.size <= MAX_FILE_SIZE)
  }
}

const isLoading = computed(() => userQuestionState.isLoading)
const user = computed(() => userState.user)

const currentTime = computed(() => {
  var today = new Date()
  return `${today.getFullYear()}-${(today.getMonth() + 1)}-${today.getDate()}`
})

const reset = () => {
  title.value = ''
  body.value = ''
  hasAsked.value = false
  isNotConfirm.value = true
  confirmed.value = false
}

const changeToConfirm = () => {
  invalidTitle.value = !title.value
  invalidBody.value = !body.value
  if (invalidTitle.value || invalidBody.value || invalidFiles.value) return
  confirmed.value = true
  isNotConfirm.value = false
}

const backToForm = () => {
  isNotConfirm.value = true
  confirmed.value = false
}

const createQuestion = async () => {
  invalidTitle.value = !title.value
  invalidBody.value = !body.value
  if (invalidTitle.value || invalidBody.value) return

  const questionForm = new UserQuestionForm()
  if (props.courseId) {
    questionForm.courseId = props.courseId
  }
  if (props.lessonId) {
    questionForm.lessonId = props.lessonId
  }

  questionForm.title = title.value
  questionForm.body = body.value
  questionForm.questionType = questionType.value
  questionForm.materials = materials.value

  const result = await userQuestionState.create(questionForm)

  hasAsked.value = true
  isNotConfirm.value = true
  confirmed.value = true
  isNotConfirm.value = true
  title.value = ''
  body.value = ''
  questionType.value = 'nomal_question'
  materials.value = []
  invalidTitle.value = false
  invalidBody.value = false
  
  if (route.name !== ROUTER_NAME.MY_COURSE_DETAIL) {
    eventBus.emit(EVENTS.QUESTION_CREATED, result)
  }

  setTimeout(() => {
    vModel.value = false
  }, mobile ? 1000 : 3000)
}

watch(vModel, () => {
  reset()
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "green",
            size: "56",
            width: "5"
          })
        ]))
      : _createCommentVNode("v-if", true),
    ( isNotConfirm.value )
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 1,
          class: "user-question-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "headline" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(!hasAsked.value ? '質問を作成する' : '質問ありがとうございました'), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            ( !hasAsked.value )
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    ( invalidTitle.value )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "タイトルを入力してください"))
                      : _createCommentVNode("v-if", true),
                    ( invalidBody.value )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "内容を入力してください"))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_text_field, {
                      modelValue:  title.value ,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
                      label: "質問のタイトル",
                      required: ""
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createVNode(Simplemde, {
                      modelValue:  body.value ,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((body).value = $event)),
                      name: "question-list",
                      rows:  3 ,
                      autoHeight: true,
                      minRows: 3,
                      maxRows: 10
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createElementVNode("div", null, [
                      ( user.value && user.value.hasActiveSubscription )
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            lg: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue:  questionType.value ,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((questionType).value = $event)),
                                label: "プライベート質問 ＊この質問は一般には公開されません",
                                "true-value": "private_question",
                                "false-value": "nomal_question",
                                class: "my-0",
                                "hide-details": ""
                              }, null, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_file_input, {
                            modelValue:  materials.value ,
                            "onUpdate:modelValue": [
                              _cache[3] || (_cache[3] = ($event: any) => ((materials).value = $event)),
                              validateFiles
                            ],
                            label: "素材をアップロード",
                            multiple: "",
                            "prepend-icon": "mdi-paperclip",
                            rules: fileRules,
                            hint: "各ファイル5MB以下",
                            "persistent-hint": ""
                          }, {
                            selection: _withCtx(({ fileNames }) => [
                              _createVNode(_component_v_chip, {
                                small: "",
                                label: "",
                                color: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(fileNames.join(', ')), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["modelValue"]),
                          ( invalidFiles.value )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "ファイルサイズは5MB以下にしてください"))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                ( !confirmed.value )
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      color: "green",
                      dark: "",
                      onClick:  changeToConfirm 
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode(" 質問を投稿する ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]))
                  : _createCommentVNode("v-if", true),
                ( !confirmed.value )
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      color: "green-darken-1",
                      text: "",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (vModel.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("キャンセル ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createBlock(_component_v_card, {
          key: 2,
          class: "user-question-dialog"
        }, {
          default: _withCtx(() => [
            ( !hasAsked.value )
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    ( invalidTitle.value )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "タイトルを入力してください"))
                      : _createCommentVNode("v-if", true),
                    ( invalidBody.value )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "内容を入力してください"))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_card_title, { class: "headline" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(title.value), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "mb-4 html-body question-confirm-body",
                          innerHTML:  _unref(markdownParser)(body.value) 
                        }, null, 8 /* PROPS */, _hoisted_8),
                        _createElementVNode("div", null, [
                          ( user.value && user.value.hasActiveSubscription )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                lg: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue:  questionType.value ,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((questionType).value = $event)),
                                    label: "プライベート質問 ＊この質問は一般には公開されません",
                                    "true-value": "private_question",
                                    "false-value": "nomal_question",
                                    class: "my-0",
                                    "hide-details": ""
                                  }, null, 8 /* PROPS */, ["modelValue"])
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              ( materials.value.length > 0 )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "素材をアップロード"))
                                : _createCommentVNode("v-if", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materials.value, (material) => {
                                return (_openBlock(), _createBlock(_component_v_col, {
                                  key:  material.name 
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(material.name), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "p-0"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_v_col, {
                                  cols: "2",
                                  class: "me-2"
                                }, {
                                  default: _withCtx(() => [
                                    ( user.value && user.value.image )
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src:  user.value.image.url ,
                                          style: {"width":"40px"}
                                        }, null, 8 /* PROPS */, _hoisted_12))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    ( user.value )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(user.value.name), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(currentTime.value) + "に質問します。", 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_divider)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_card_actions, { class: "question-btn" }, {
              default: _withCtx(() => [
                ( !hasAsked.value )
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      color: "green",
                      dark: "",
                      onClick:  createQuestion 
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" 質問を投稿する ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]))
                  : _createCommentVNode("v-if", true),
                ( !hasAsked.value )
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      color: "green-darken-1",
                      text: "",
                      onClick:  backToForm 
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("修正する ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]))
                  : _createCommentVNode("v-if", true),
                ( hasAsked.value )
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 2,
                      color: "green-darken-1",
                      text: "",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (vModel.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("OK ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
  ]))
}
}

})